import { professionalConstants } from "../_constants";
import { professionalService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { pushNotificationService } from "../_services/pushNotification";

export const professionalAction = {
  getAllMaster,
  getCity,
  getDistrict,
  getDharm,
  getKayda,
  getKalam,
  getStatus,
  getSpot,
  getSadyasthiti,
  getCrimeTitle,
  getCrimeType,
  getAboutCIMS,
  createCriminal,
  getCriminalsById,
  updateCriminals,
  updateCriminalActiveStatus,
  getCriminalsTableInfoById,
  getCriminalsViewsById,
  getCriminalsViewsByIdView,
  uploadImage,
  createNews,
  getNews,
  getAllNews,
  updateNews,
  getGPSInformation,
  getCCTVLocations,
  getGPSInformationSuccess,
  getReport3,
  getReport1,
  getReport4,
  getActiveAndNonActiveGpsInforByMasterId,
  markAsLockAddress,
  getTotalAppUsersCount,
  getTotalCriminalCount,
  getTotalRegisterPoliceStationCount,
  getTotalTodayGPSCount,
  pushNotification,
  getAllCount,
  getDashboardCount,
  getCriminalsTableInfo,
  getCriminalsTableInfobyName,
  getCriminalsTableInfobyNameNew,
  getReportAdminSpotvise,
  getReportPoliceSpotvise,
  get2PlusReports,
  getPoliceStation2PlusReports,
  createPreventiveAction,
  getPreventiveToolByID,
  updatePreventive,
  getPreventiveAction,
  get2PlusCriminalsViewsById,
  getCriminalsAppInfoByCitySerach,
  getUserCriminalsAppInfoBySerach,
  getExportCriminalByCityId,
  getSearchCriminalsTableInfoByDistrictId,
  getGpsInformationWithFilter,
  getFilterCriminalsTableInfoByCityId,
  getFilterCriminalsTableInfoByUserId,
  getFilterByGunaCriminalsTableInfoByCityId,
  getFilterReport,
  searchOngoingReport,
  searchCompletedReport,
  getSearchPreventiveList,
  getOngoingSearchReport,
  getCompletedSearchReport,
  getPSCriminalsTableInfoByUserId,
  getFilterByGunaCriminalsTableInfoByDistrictId,
  getFilterSearchCriminalsTableInfoByCityId,
  getFilterSearchCriminalsTableInfoByUserId,
  getFilterCriminalsTableInfoByDistrictId,
  getFilterSearchCriminalsTableInfoByDistrictId,
  createArrestAction,
  updateArrestAction,
  getArrestInformationbyId,
  getArrestReport,
  createNoticeInformation,
  updateNoticeInformation,
  getCriminalsAppInfoByUserSerach,
  getCriminalsAppInfoByDistrictSerach,
  getPreventiveList,
  getPreventiveCount,
  getPreventiveCountList,
  getOngoingPreventiveCountList,
  OngoingPreventiveActionListById,
  getCompletedPreventiveCountList,
  getActiveCities,
  getVerificationAllocation,
  AllocatedGagDetectionCityId,
  getAppUsers,
  saveVerificationAllocation,
  AllocatedVerificationList,
  generateOtp,
  addVehicalDetailsThirdParty,
  addVehicalDetails,
  addDrivinglicenceThirdParty,
  addDrivinglicence,
  addAadharBasicThirdParty,
  addAadharBasic,
  addAadharotpThirdParty,
  addAadharotp,
  addPancomprehensiv,
  addPassportThirdParty,
  addPassport,
  addVoterThirdParty,
  addVoter,
  getVehicleDetails,
  getVoterDetails,
  getPassportDetails,
  getDrivingLicenseDetails,
  getAadharBasicDetails,
  getAadharOtpDetails,
  getPoliceStationWithGhatak,
  searchByGunhaCount,
  getOngoingPreventiveActionCount,
  getOngoingPreventiveActionList,
  getCompletedPreventiveActionCount,
  getCompletedPreventiveActionList,
  saveActs,
  saveSections,
  searchAddedKalam,
  getGPSCount,
  getPreventiveActionCount,
  get2PlusCount,
  getGunainfoSubHeadingByFilter,
  getGunhaInfoByFilter,
  getCriminalsNotFilledPoliceStationHeadingFilter,
  getGunaHeadingNotFilledPoliceStationArophiFilter,
  getCriminalsFilledPoliceStationHeadingFilter,
  getGunaHeadingFilledPoliceStationArophiFilter,
  filledPoliceStationDaily,
  notFilledPoliceStationDaily,
  totalappuserCount,
  totaltwoplusCount,
  preventionActionCount,
  surveillanceCount,
  getWanted,
  getWantedByDistrict,
  getGpsinformationPoliceStation,
  getNewPreventiveList,
  getNewPreventiveActionCount,
  getSearchNewPreventiveList,
  getCompletedPreventiveListById,
  getPreventiveListById,
  getNewPreventiveListById,
  CompletedPreventiveActionListById,
  getDistrictsid,
  languageSave,
  lanaguagesearch,
  getCrimeSubTitleByTitle,
  getGunaWiseYear,
  gunaYearWiseFilledAPI,
  gunaYearWiseNotFilledAPI,
  getTadipaarByCity,
  getTadipaarByPS,
  getTadipaarCountByCity,
  getWantedCountByCity,
  getPhotoStatusFilterByUserId,
  getPhotoStatusFilterByDistrict,
  getPhotoStatusFilterByCity,
  getNewCriminalsTableInfobydistrictName,
  postSearchHistory,
  getGunaReportPoliceSide,
  getBasicInformationByRegisterNumber,
  getGunareportByTitle,
  getCountGunaReportAdmin,
  getListGunaReportAdmin,
  getGunaTitleAdmin,
  noticeReport,
  getCrimeTitleByTitleId,
  getMainHead,
  CreateModasoperandi,
  ListModasoperandi,
  CountModasoperandiHeadWise,
  ModasoperandiHeadId,
  getCountry,
  updateCountry,
  getStatesWiseCityData,
  getAllocatedImageProvisionByCity,
};

function getAllMaster() {
  return (dispatch) => {
    professionalService.getAllMaster().then(
      (professionals) => {
        dispatch(success(professionals));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function success(professionals) {
    return {
      type: professionalConstants.GET_MASTER_SUCCESS,
      professionals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_MASTER_FAILURE,
      error,
    };
  }
}

function getCity() {
  return (dispatch) => {
    professionalService.getCity().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function success(cities) {
    return {
      type: professionalConstants.GET_CITY_SUCCESS,
      cities,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CITY_FAILURE,
      error,
    };
  }
}

function getDistrict(cityId, form) {
  return (dispatch) => {
    professionalService.getDistrict(cityId).then(
      (response) => {
        if (form === 1) {
          dispatch(success_BasicForm(response));
        } else if (form === 2) {
          dispatch(success_GunhaFrom(response));
        }
      },
      (error) => {
        if (form === "1") {
          dispatch(failure_BasicForm(error));
        } else if (form === "2") {
          dispatch(failure_GunhaFrom(error));
        }
      },
    );
  };

  function success_BasicForm(districts) {
    return {
      type: professionalConstants.GET_DISTRICT_BASICINFO_SUCCESS,
      districts,
    };
  }

  function failure_BasicForm(error) {
    return {
      type: professionalConstants.GET_DISTRICT_BASICINFO_FAILURE,
      error,
    };
  }

  function success_GunhaFrom(districts) {
    return {
      type: professionalConstants.GET_DISTRICT_GUNHA_SUCCESS,
      districts,
    };
  }

  function failure_GunhaFrom(error) {
    return {
      type: professionalConstants.GET_DISTRICT_GUNHA_FAILURE,
      error,
    };
  }
}

function getDharm() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getDharm().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(dharm) {
    return {
      type: professionalConstants.GET_DHARM_REQUEST,
      dharm,
    };
  }

  function success(dharm) {
    return {
      type: professionalConstants.GET_DHARM_SUCCESS,
      dharm,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_DHARM_FAILURE,
      error,
    };
  }
}

function getKayda() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getKayda().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(kayda) {
    return {
      type: professionalConstants.GET_KAYDA_REQUEST,
      kayda,
    };
  }

  function success(kayda) {
    return {
      type: professionalConstants.GET_KAYDA_SUCCESS,
      kayda,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_KAYDA_FAILURE,
      error,
    };
  }
}

function getKalam(actId) {
  return (dispatch) => {
    dispatch(request());
    professionalService.getKalam(actId).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(kalam) {
    return {
      type: professionalConstants.GET_KALAM_REQUEST,
      kalam,
    };
  }

  function success(kalam) {
    return {
      type: professionalConstants.GET_KALAM_SUCCESS,
      kalam,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_KALAM_FAILURE,
      error,
    };
  }
}

function getCrimeType() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getCrimeType().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(crimeTypes) {
    return {
      type: professionalConstants.GET_CRIMETYPE_REQUEST,
      crimeTypes,
    };
  }

  function success(crimeTypes) {
    return {
      type: professionalConstants.GET_CRIMETYPE_SUCCESS,
      crimeTypes,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CRIMETYPE_FAILURE,
      error,
    };
  }
}

function getCrimeTitle() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getCrimeTitle().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(crimeTitle) {
    return {
      type: professionalConstants.GET_CRIMETITLE_REQUEST,
      crimeTitle,
    };
  }

  function success(crimeTitle) {
    return {
      type: professionalConstants.GET_CRIMETITLE_SUCCESS,
      crimeTitle,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CRIMETITLE_FAILURE,
      error,
    };
  }
}

function getStatus() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getStatus().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(status) {
    return {
      type: professionalConstants.GET_STATUS_REQUEST,
      status,
    };
  }

  function success(status) {
    return {
      type: professionalConstants.GET_STATUS_SUCCESS,
      status,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_STATUS_FAILURE,
      error,
    };
  }
}

function getSpot() {
  return (dispatch) => {
    dispatch(request());
    professionalService.getSpot().then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(status) {
    return {
      type: professionalConstants.GET_SPOT_REQUEST,
      status,
    };
  }

  function success(status) {
    return {
      type: professionalConstants.GET_SPOT_SUCCESS,
      status,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_SPOT_FAILURE,
      error,
    };
  }
}

function getSadyasthiti() {
  return professionalService.getSadyasthiti();
}

function createCriminal(data) {
  return (dispatch) => {
    dispatch(request());
    professionalService.createCriminal(data).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_CREATE_CRIMINAL_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_CREATE_CRIMINAL_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CREATE_CRIMINAL_FAILURE,
      error,
    };
  }
}

function createPreventiveAction(data) {
  return (dispatch) => {
    dispatch(request());
    professionalService.createPreventiveAction(data).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_CREATE_PREVENT_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_CREATE_PREVENT_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CREATE_PREVENT_FAILURE,
      error,
    };
  }
}

function createArrestAction(data) {
  return (dispatch) => {
    dispatch(request());
    return professionalService.createArrestAction(data).then(
      (response) => {
        dispatch(success(response));
        return response;
      },
      (error) => {
        dispatch(failure(error));
        return null;
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_CREATE_ARREST_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_CREATE_ARREST_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CREATE_ARREST_FAILURE,
      error,
    };
  }
}

function updateArrestAction(data, id) {
  let reqObj = {
    ...data,
    id,
  };

  return (dispatch) => {
    dispatch(request());
    return professionalService.updateArrestAction(data, id).then(
      (response) => {
        dispatch(success(response));
        return response;
      },
      (error) => {
        dispatch(failure(error));
        return null;
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_UPDATE_ARREST_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_UPDATE_ARREST_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_UPDATE_ARREST_FAILURE,
      error,
    };
  }
}

function createNews(data) {
  return (dispatch) => {
    dispatch(request());
    professionalService.createNews(data).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(news) {
    return {
      type: professionalConstants.SAVE_NEWS_REQUEST,
      news,
    };
  }

  function success(news) {
    return {
      type: professionalConstants.SAVE_NEWS_SUCCESS,
      news,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.SAVE_NEWS_FAILURE,
      error,
    };
  }
}

function createNoticeInformation(data) {
  return (dispatch) => {
    dispatch(request());
    return professionalService.createNoticeInformation(data).then(
      (response) => {
        dispatch(success(response));
        return response;
      },
      (error) => {
        dispatch(failure(error));
        return null;
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_CREATE_NOTICE_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_CREATE_NOTICE_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_CREATE_NOTICE_FAILURE,
      error,
    };
  }
}
function updateNoticeInformation(data, id) {
  let reqObj = {
    ...data,
    id,
  };

  return (dispatch) => {
    dispatch(request());
    return professionalService.updateNoticeInformation(data, id).then(
      (response) => {
        dispatch(success(response));
        return response;
      },
      (error) => {
        dispatch(failure(error));
        return null;
      },
    );
  };

  function request(criminals) {
    return {
      type: professionalConstants.GET_UPDATE_NOTICE_REQUEST,
      criminals,
    };
  }

  function success(criminals) {
    return {
      type: professionalConstants.GET_UPDATE_NOTICE_SUCCESS,
      criminals,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_UPDATE_NOTICE_FAILURE,
      error,
    };
  }
}

function getCCTVLocations(cityId) {
  return professionalService.getCCTVLocations(cityId);
}

function getGPSInformation(cityId) {
  // dispatch(request());
  return professionalService.getGPSInformation(cityId);

  // function request(gpsInformation) {
  //     return {
  //         type: professionalConstants.GET_GPS_INFORMATION_REQUEST,
  //         gpsInformation
  //     }
  // }

  // function success(gpsInformation) {
  //     return {
  //         type: professionalConstants.GET_GPS_INFORMATION_SUCCESS,
  //         gpsInformation
  //     }
  // }

  // function failure(error) {
  //     return {
  //         type: professionalConstants.GET_GPS_INFORMATION_FAILURE,
  //         error
  //     }
  // }
}

function getGpsinformationPoliceStation(id) {
  // dispatch(request());
  return professionalService.getGpsinformationPoliceStation(id);
}
function getGPSInformationSuccess(gpsInformation) {
  return (dispatch) => {
    dispatch(success(gpsInformation));
  };
  function success(gpsInformation) {
    return {
      type: professionalConstants.GET_GPS_INFORMATION_SUCCESS,
      gpsInformation,
    };
  }
}

function getNews(itemType, role, cityId) {
  return (dispatch) => {
    dispatch(request());
    professionalService.getNews(itemType, role, cityId).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(news) {
    return {
      type: professionalConstants.GET_NEWS_REQUEST,
      news,
    };
  }

  function success(news) {
    return {
      type: professionalConstants.GET_NEWS_SUCCESS,
      news,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_NEWS_FAILURE,
      error,
    };
  }
}
function getAllNews(itemType) {
  return (dispatch) => {
    dispatch(request());
    professionalService.getAllNews(itemType).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(news) {
    return {
      type: professionalConstants.GET_NEWS_REQUEST,
      news,
    };
  }

  function success(news) {
    return {
      type: professionalConstants.GET_NEWS_SUCCESS,
      news,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.GET_NEWS_FAILURE,
      error,
    };
  }
}

function updateNews(id, data) {
  let reqObj = {
    ...data,
    id,
  };

  return (dispatch) => {
    dispatch(request());
    professionalService.updateNews(id, data).then(
      (response) => {
        dispatch(success(reqObj));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(news) {
    return {
      type: professionalConstants.UPDATE_NEWS_REQUEST,
      news,
    };
  }

  function success(news) {
    return {
      type: professionalConstants.UPDATE_NEWS_SUCCESS,
      news,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.UPDATE_NEWS_FAILURE,
      error,
    };
  }
}

function getCriminalsById(id) {
  return (dispatch) => {
    // dispatch(request());
    return professionalService.getCriminalsById(id);
    // .then((response) => {
    //     dispatch(success(response));
    // }, error => {
    //     dispatch(failure(error));
    // })
    // }

    // function request(criminalsList) {
    //     return {
    //         type: professionalConstants.GET_CRIMINALS_BY_ID_REQUEST,
    //         criminalsList
    //     }
    // }

    // function success(criminalsList) {
    //     return {
    //         type: professionalConstants.GET_CRIMINALS_BY_ID_SUCCESS,
    //         criminalsList
    //     }
    // }

    // function failure(error) {
    //     return {
    //         type: professionalConstants.GET_CRIMINALS_BY_ID_FAILURE,
    //         error
    //     }
    // }
  };
}

function getCriminalsViewsById(id) {
  return (dispatch) => {
    dispatch(request());
    professionalService.getCriminalsById(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );

    function request(criminalViewList) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_REQUEST,
        criminalViewList,
      };
    }

    function success(criminalViewList) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_SUCCESS,
        criminalViewList,
      };
    }

    function failure(error) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_FAILURE,
        error,
      };
    }
  };
}

function getCriminalsViewsByIdView(id) {
  return (dispatch) => {
    dispatch(request());
    professionalService.getCriminalsByIdView(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );

    function request(criminalViewList) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_REQUEST,
        criminalViewList,
      };
    }

    function success(criminalViewList) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_SUCCESS,
        criminalViewList,
      };
    }

    function failure(error) {
      return {
        type: professionalConstants.GET_CRIMINALS_BY_ID_FAILURE,
        error,
      };
    }
  };
}

function getCriminalsTableInfo(falg, id, control) {
  return professionalService.getCriminalsTableInfo(falg, id, control);
}

function getCriminalsTableInfobyName(id, seatchText) {
  return professionalService.getCriminalsTableInfobyName(id, seatchText);
}

function getCriminalsTableInfobyNameNew(values) {
  return professionalService.getCriminalsTableInfobyNameNew(values);
}

function getCriminalsTableInfoById(falg, id, control, page, size) {
  return professionalService.getCriminalsTableInfoById(
    falg,
    id,
    control,
    page,
    size,
  );
  // return dispatch => {
  //     dispatch(request());
  //     professionalService.getCriminalsTableInfoById(falg, id, control)
  //         .then((response) => {
  //             dispatch(success(response));
  //         }, error => {
  //             dispatch(failure(error));
  //         })
  // }

  // function request(criminalsTableList) {
  //     return {
  //         type: professionalConstants.GET_CRIMINALS_TABLE_BY_ID_REQUEST,
  //         criminalsTableList
  //     }
  // }

  // function success(criminalsTableList) {
  //     return {
  //         type: professionalConstants.GET_CRIMINALS_TABLE_BY_ID_SUCCESS,
  //         criminalsTableList
  //     }
  // }

  // function failure(error) {
  //     return {
  //         type: professionalConstants.GET_CRIMINALS_TABLE_BY_ID_FAILURE,
  //         error
  //     }
  // }
}
function updateCriminalActiveStatus(id, data) {
  return professionalService.updateCriminalActiveStatus(id, data);
}

function updateCriminals(id, data) {
  return (dispatch) => {
    dispatch(request());
    professionalService.updateCriminals(id, data).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(criminalsUpdatedList) {
    return {
      type: professionalConstants.GET_CRIMINALS_BY_ID_REQUEST,
      criminalsUpdatedList,
    };
  }

  function success(criminalsUpdatedList) {
    return {
      type: professionalConstants.UPDATE_CRIMINALS_BY_ID_SUCCESS,
      criminalsUpdatedList,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.UPDATE_CRIMINALS_BY_ID_FAILURE,
      error,
    };
  }
}

function updatePreventive(id, data) {
  return (dispatch) => {
    dispatch(request());
    professionalService.updatePreventive(id, data).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request(preventiveUpdatedList) {
    return {
      type: professionalConstants.UPDATE_PREVENTIVE_BY_ID_REQUEST,
      preventiveUpdatedList,
    };
  }

  function success(preventiveUpdatedList) {
    return {
      type: professionalConstants.UPDATE_PREVENTIVE_BY_ID_SUCCESS,
      preventiveUpdatedList,
    };
  }

  function failure(error) {
    return {
      type: professionalConstants.UPDATE_PREVENTIVE_BY_ID_FAILURE,
      error,
    };
  }
}

function getAboutCIMS() {
  return professionalService.getAboutCIMS();
}

function uploadImage(data) {
  return (dispatch) => {
    // dispatch(request());
    return professionalService.uploadImage(data);
    // .then((response) => {
    //     dispatch(success(response));
    // }, error => {
    //   ///  dispatch(failure(error));
    // })
  };

  // function request(criminalsUpdatedList) {
  //     return {
  //         type: professionalConstants.GET_CRIMINALS_BY_ID_REQUEST,
  //         criminalsUpdatedList
  //     }
  // }

  // function success(criminalsUpdatedList) {
  //     return {
  //         type: professionalConstants.UPDATE_CRIMINALS_BY_ID_SUCCESS,
  //         criminalsUpdatedList
  //     }
  // }

  // function failure(error) {
  //     return {
  //         type: professionalConstants.UPDATE_CRIMINALS_BY_ID_FAILURE,
  //         error
  //     }
  // }
}

function get2PlusReports(data) {
  return professionalService.get2PlusReports(data);
}
function getPoliceStation2PlusReports(data) {
  return professionalService.getPoliceStation2PlusReports(data);
}

function getArrestReport(data) {
  return professionalService.getArrestReport(data);
}

function getReport3(data) {
  return professionalService.getReport3(data);
}
function getReport1(data) {
  return professionalService.getReport1(data);
}
function getReport4(data) {
  return professionalService.getReport4(data);
}

function getReportAdminSpotvise(data) {
  return professionalService.getReportAdminSpotvise(data);
}

function getReportPoliceSpotvise(data) {
  return professionalService.getReportPoliceSpotvise(data);
}

function getActiveAndNonActiveGpsInforByMasterId(masterid) {
  return professionalService.getActiveAndNonActiveGpsInforByMasterId(masterid);
}

function markAsLockAddress(data) {
  return professionalService.markAsLockAddress(data);
}

function getTotalAppUsersCount(role, cityId) {
  return professionalService.getTotalAppUsersCount(role, cityId);
}
function getTotalCriminalCount(role, cityId) {
  return professionalService.getTotalCriminalCount(role, cityId);
}
function getTotalRegisterPoliceStationCount(role, cityId) {
  return professionalService.getTotalRegisterPoliceStationCount(role, cityId);
}
function getTotalTodayGPSCount(role, cityId) {
  return professionalService.getTotalTodayGPSCount(role, cityId);
}

function getAllCount(role, cityId) {
  return professionalService.getAllCount(role, cityId);
}

function getDashboardCount(cityId) {
  return professionalService.getDashboardCount(cityId);
}

function pushNotification(data) {
  return pushNotificationService.pushNotification(data);
}

function getPreventiveToolByID(id) {
  return professionalService.getPreventiveToolByID(id);
}
function getArrestInformationbyId(id) {
  return professionalService.getArrestInformationbyId(id);
}

function getPreventiveAction() {
  return professionalService.getPreventiveAction();
}

function get2PlusCriminalsViewsById(data) {
  //return professionalService.get2PlusCriminalsViewsById(data)
  return (dispatch) => {
    dispatch(request());
    professionalService.getCriminalsById(data.id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );

    function request(criminalPlusList) {
      return {
        type: professionalConstants.GET_CRIMINALS_PLUS_BY_ID_REQUEST,
        criminalPlusList,
      };
    }

    function success(criminalPlusList) {
      return {
        type: professionalConstants.GET_CRIMINALS_PLUS_BY_ID_SUCCESS,
        criminalPlusList,
      };
    }

    function failure(error) {
      return {
        type: professionalConstants.GET_CRIMINALS_PLUS_BY_ID_FAILURE,
        error,
      };
    }
  };
}

function getCriminalsAppInfoByCitySerach(city, searchText, page, size) {
  return professionalService.getCriminalsAppInfoByCitySerach(
    city,
    searchText,
    page,
    size,
  );
}

function getUserCriminalsAppInfoBySerach(id, searchText, page, size) {
  return professionalService.getUserCriminalsAppInfoBySerach(
    id,
    searchText,
    page,
    size,
  );
}

function getExportCriminalByCityId(city) {
  return professionalService.getExportCriminalByCityId(city);
}

function getSearchCriminalsTableInfoByDistrictId(id, searchText, page, size) {
  return professionalService.getSearchCriminalsTableInfoByDistrictId(
    id,
    searchText,
    page,
    size,
  );
}

function getCriminalsAppInfoByUserSerach(id, searchText, page, size) {
  return professionalService.getCriminalsAppInfoByUserSerach(
    id,
    searchText,
    page,
    size,
  );
}

function getCriminalsAppInfoByDistrictSerach(id, searchText, page, size) {
  return professionalService.getCriminalsAppInfoByDistrictSerach(
    id,
    searchText,
    page,
    size,
  );
}

function getPreventiveList(data) {
  return professionalService.getPreventiveList(data);
}

function getGpsInformationWithFilter(data) {
  return professionalService.getGpsInformationWithFilter(data);
}

function getFilterCriminalsTableInfoByCityId(
  Id,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterCriminalsTableInfoByCityId(
    Id,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterCriminalsTableInfoByUserId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterCriminalsTableInfoByUserId(
    cityId,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterByGunaCriminalsTableInfoByCityId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterByGunaCriminalsTableInfoByCityId(
    cityId,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterReport(
  startDate,
  endDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  return professionalService.getFilterReport(
    startDate,
    endDate,
    Id,
    orderBy,
    orderDirection,
    preventive_action,
  );
}

function searchOngoingReport(
  selectedDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  return professionalService.searchOngoingReport(
    selectedDate,
    Id,
    orderBy,
    orderDirection,
    preventive_action,
  );
}

function searchCompletedReport(
  selectedDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  return professionalService.searchCompletedReport(
    selectedDate,
    Id,
    orderBy,
    orderDirection,
    preventive_action,
  );
}

function getPSCriminalsTableInfoByUserId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getPSCriminalsTableInfoByUserId(
    cityId,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterByGunaCriminalsTableInfoByDistrictId(
  districtId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterByGunaCriminalsTableInfoByDistrictId(
    districtId,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterSearchCriminalsTableInfoByCityId(
  cityId,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterSearchCriminalsTableInfoByCityId(
    cityId,
    search,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getSearchPreventiveList(
  startDate,
  endDate,
  cityId,
  search,
  preventive_action,
) {
  return professionalService.getSearchPreventiveList(
    startDate,
    endDate,
    cityId,
    search,
    preventive_action,
  );
}

function getOngoingSearchReport(values) {
  return professionalService.getOngoingSearchReport(values);
}

function getCompletedSearchReport(
  startDate,
  cityId,
  search,
  preventive_action,
) {
  return professionalService.getCompletedSearchReport(
    startDate,
    cityId,
    search,
    preventive_action,
  );
}

function getFilterSearchCriminalsTableInfoByUserId(
  Id,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterSearchCriminalsTableInfoByUserId(
    Id,
    search,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterCriminalsTableInfoByDistrictId(
  districtId,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterCriminalsTableInfoByDistrictId(
    districtId,
    search,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getFilterSearchCriminalsTableInfoByDistrictId(
  districtId,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  return professionalService.getFilterSearchCriminalsTableInfoByDistrictId(
    districtId,
    page,
    size,
    orderBy,
    orderDirection,
  );
}

function getPreventiveCount(data) {
  return professionalService.getPreventiveCount(data);
}

function getPreventiveCountList(data) {
  return professionalService.getPreventiveCountList(data);
}

function getOngoingPreventiveCountList(data) {
  return professionalService.getOngoingPreventiveCountList(data);
}

function getCompletedPreventiveCountList(data) {
  return professionalService.getCompletedPreventiveCountList(data);
}

function getActiveCities(id) {
  return professionalService.getActiveCities();
}

function getVerificationAllocation(cityId) {
  return professionalService.getVerificationAllocation(cityId);
}

function AllocatedGagDetectionCityId(cityid) {
  return professionalService.AllocatedGagDetectionCityId(cityid);
}
function getAppUsers(cityId) {
  return professionalService.getAppUsers(cityId);
}

function saveVerificationAllocation(data) {
  return professionalService.saveVerificationAllocation(data);
}

function AllocatedVerificationList() {
  return professionalService.AllocatedVerificationList();
}

function generateOtp(data) {
  return professionalService.generateOtp(data);
}

function addVehicalDetailsThirdParty(data) {
  return professionalService.addVehicalDetailsThirdParty(data);
}

function addVehicalDetails(data) {
  return professionalService.addVehicalDetails(data);
}

function addDrivinglicenceThirdParty(data) {
  return professionalService.addDrivinglicenceThirdParty(data);
}

function addDrivinglicence(data) {
  return professionalService.addDrivinglicence(data);
}

function addAadharBasicThirdParty(data) {
  return professionalService.addAadharBasicThirdParty(data);
}

function addAadharBasic(data) {
  return professionalService.addAadharBasic(data);
}

function addAadharotpThirdParty(data) {
  return professionalService.addAadharotpThirdParty(data);
}

function addAadharotp(data) {
  return professionalService.addAadharotp(data);
}

function addPancomprehensiv(data) {
  return professionalService.addPancomprehensiv(data);
}

function addPassportThirdParty(data) {
  return professionalService.addPassportThirdParty(data);
}

function addPassport(data) {
  return professionalService.addPassport(data);
}

function addVoterThirdParty(data) {
  return professionalService.addVoterThirdParty(data);
}

function addVoter(data) {
  return professionalService.addVoter(data);
}

function getVehicleDetails(userId, page, size, orderDirection) {
  return professionalService.getVehicleDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getVoterDetails(userId, page, size, orderDirection) {
  return professionalService.getVoterDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getPassportDetails(userId, page, size, orderDirection) {
  return professionalService.getPassportDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getDrivingLicenseDetails(userId, page, size, orderDirection) {
  return professionalService.getDrivingLicenseDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getAadharBasicDetails(userId, page, size, orderDirection) {
  return professionalService.getAadharBasicDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getAadharOtpDetails(userId, page, size, orderDirection) {
  return professionalService.getAadharOtpDetails(
    userId,
    page,
    size,
    orderDirection,
  );
}

function getPoliceStationWithGhatak(userId) {
  return professionalService.getPoliceStationWithGhatak(userId);
}

function searchByGunhaCount(data) {
  return professionalService.searchByGunhaCount(data);
}

function getOngoingPreventiveActionCount(data) {
  return professionalService.getOngoingPreventiveActionCount(data);
}

function getOngoingPreventiveActionList(data) {
  return professionalService.getOngoingPreventiveActionList(data);
}

function getCompletedPreventiveActionCount(data) {
  return professionalService.getCompletedPreventiveActionCount(data);
}

function getCompletedPreventiveActionList(data) {
  return professionalService.getCompletedPreventiveActionList(data);
}

function saveActs(data) {
  return professionalService.saveActs(data);
}

function saveSections(data) {
  return professionalService.saveSections(data);
}

function searchAddedKalam(data) {
  return professionalService.searchAddedKalam(data);
}

function getGPSCount(cityId, date) {
  return professionalService.getGPSCount(cityId, date);
}

function getPreventiveActionCount(cityId, date) {
  return professionalService.getPreventiveActionCount(cityId, date);
}

function get2PlusCount(cityId, date) {
  return professionalService.get2PlusCount(cityId, date);
}

function getGunainfoSubHeadingByFilter(values) {
  return professionalService.getGunainfoSubHeadingByFilter(values);
}

function getGunhaInfoByFilter(values) {
  return professionalService.getGunhaInfoByFilter(values);
}

function getCriminalsNotFilledPoliceStationHeadingFilter(values) {
  return professionalService.getCriminalsNotFilledPoliceStationHeadingFilter(
    values,
  );
}

function getGunaHeadingNotFilledPoliceStationArophiFilter(values) {
  return professionalService.getGunaHeadingNotFilledPoliceStationArophiFilter(
    values,
  );
}

function getCriminalsFilledPoliceStationHeadingFilter(values) {
  return professionalService.getCriminalsFilledPoliceStationHeadingFilter(
    values,
  );
}

function getGunaHeadingFilledPoliceStationArophiFilter(values) {
  return professionalService.getGunaHeadingFilledPoliceStationArophiFilter(
    values,
  );
}

function filledPoliceStationDaily(values) {
  return professionalService.filledPoliceStationDaily(values);
}

function notFilledPoliceStationDaily(values) {
  return professionalService.notFilledPoliceStationDaily(values);
}

function totalappuserCount(values) {
  return professionalService.totalappuserCount(values);
}

function totaltwoplusCount(values) {
  return professionalService.totaltwoplusCount(values);
}

function preventionActionCount(values) {
  return professionalService.preventionActionCount(values);
}

function surveillanceCount(values) {
  return professionalService.surveillanceCount(values);
}
function getWanted(cityId, value) {
  return professionalService.getWanted(cityId, value);
}
function getWantedByDistrict(district, value) {
  return professionalService.getWantedByDistrict(district, value);
}

function getNewPreventiveList(values) {
  return professionalService.getNewPreventiveList(values);
}

function getNewPreventiveActionCount(values) {
  return professionalService.getNewPreventiveActionCount(values);
}

function getSearchNewPreventiveList(values) {
  return professionalService.getSearchNewPreventiveList(values);
}
function OngoingPreventiveActionListById(values) {
  return professionalService.OngoingPreventiveActionListById(values);
}
function getCompletedPreventiveListById(values) {
  return professionalService.getCompletedPreventiveListById(values);
}
function getPreventiveListById(values) {
  return professionalService.getPreventiveListById(values);
}
function getNewPreventiveListById(values) {
  return professionalService.getNewPreventiveListById(values);
}
function CompletedPreventiveActionListById(values) {
  return professionalService.CompletedPreventiveActionListById(values);
}

function getDistrictsid(id) {
  return professionalService.getDistrictsid(id);
}

function languageSave(values) {
  return professionalService.languageSave(values);
}

function lanaguagesearch(id) {
  return professionalService.lanaguagesearch(id);
}

function getCrimeSubTitleByTitle(id) {
  return professionalService.getCrimeSubTitleByTitle(id);
}
function getGunaWiseYear(values) {
  return professionalService.getGunaWiseYear(values);
}
function gunaYearWiseFilledAPI(values) {
  return professionalService.gunaYearWiseFilledAPI(values);
}
function gunaYearWiseNotFilledAPI(values) {
  return professionalService.gunaYearWiseNotFilledAPI(values);
}
function getTadipaarByCity(values) {
  return professionalService.getTadipaarByCity(values);
}
function getTadipaarByPS(values) {
  return professionalService.getTadipaarByPS(values);
}
function getTadipaarCountByCity(values) {
  return professionalService.getTadipaarCountByCity(values);
}
function getWantedCountByCity(values) {
  return professionalService.getWantedCountByCity(values);
}

function getPhotoStatusFilterByUserId(values) {
  return professionalService.getPhotoStatusFilterByUserId(values);
}

function getPhotoStatusFilterByDistrict(values) {
  return professionalService.getPhotoStatusFilterByDistrict(values);
}
function getPhotoStatusFilterByCity(values) {
  return professionalService.getPhotoStatusFilterByCity(values);
}
function getNewCriminalsTableInfobydistrictName(values) {
  return professionalService.getNewCriminalsTableInfobydistrictName(values);
}
function postSearchHistory(values) {
  return professionalService.postSearchHistory(values);
}
function getGunaReportPoliceSide(values) {
  return professionalService.getGunaReportPoliceSide(values);
}
function getBasicInformationByRegisterNumber(values) {
  return professionalService.getBasicInformationByRegisterNumber(values);
}
function getGunareportByTitle(values) {
  return professionalService.getGunareportByTitle(values);
}
function getCountGunaReportAdmin(values) {
  return professionalService.getCountGunaReportAdmin(values);
}
function getListGunaReportAdmin(values) {
  return professionalService.getListGunaReportAdmin(values);
}
function getGunaTitleAdmin(values) {
  return professionalService.getGunaTitleAdmin(values);
}
function noticeReport(values) {
  return professionalService.noticeReport(values);
}

function getCrimeTitleByTitleId(values) {
  return professionalService.getCrimeTitleByTitleId(values);
}
function getMainHead() {
  return professionalService.getMainHead();
}
function CreateModasoperandi(values) {
  return professionalService.CreateModasoperandi(values);
}
function ListModasoperandi() {
  return professionalService.ListModasoperandi();
}
function CountModasoperandiHeadWise() {
  return professionalService.CountModasoperandiHeadWise();
}
function ModasoperandiHeadId(id) {
  return professionalService.ModasoperandiHeadId(id);
}
function getCountry() {
  return professionalService.getCountry();
}
function updateCountry(values) {
  return professionalService.updateCountry(values);
}
function getStatesWiseCityData(id) {
  return professionalService.getStatesWiseCityData(id);
}

function getAllocatedImageProvisionByCity(cityId) {
  return professionalService.getAllocatedImageProvisionByCity(cityId);
}
